import { put, call, select } from 'redux-saga/effects';
import queryString from 'query-string';

// CONSTANTS
import * as endpoints from '@/constants/api-wp';
import { axiosWP } from '@/store/configDefaultAPI';

// UTILITY
import { formatExtLinks } from '@/utility/common';
import getErrorMessage from '@/utility/errors';
import { showErrorNotification } from '@/utility/saga';

// STORE
import { WPBlogActions } from '../actions';

function* formatPostContent(content) {
  const storeAnonymousId = yield select(({ auth }) => auth.anonymousId);

  return formatExtLinks(content, { unique_id: storeAnonymousId });
}

function* getUpdatedWPData(data) {
  let updatedData = { ...data };
  const content = data?.content?.rendered;

  if (content) {
    const updatedContent = yield formatPostContent(content);

    updatedData = {
      ...updatedData,
      content: {
        ...updatedData.content,
        rendered: updatedContent,
      },
    };
  }

  return updatedData;
}

const getPartnerSlug = ({ auth }) => auth.partner.slug || '';

export function* getWPPageSaga(action) {
  yield put({ type: WPBlogActions.getWPPage.types.START });

  const partner = yield select(getPartnerSlug);
  const { slug } = action.payload;

  try {
    const { data } = yield axiosWP.get(endpoints.WP_GET_PAGES, {
      params: { slug, _embed: true, partner },
      paramsSerializer: paramsData => {
        return queryString.stringify(paramsData, {
          skipEmptyString: true,
        });
      },
    });

    let postData = {};

    if (data[0]) {
      postData = yield call(getUpdatedWPData, data[0]);
    }

    yield put({
      type: WPBlogActions.getWPPage.types.SUCCESS,
      payload: {
        data: postData,
      },
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: WPBlogActions.getWPPage.types.FAIL,
      payload: { errorMessage: getErrorMessage(error) },
    });
  }
}

export default getWPPageSaga;
